import React, { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import OnboardingFlow from './OnboardingFlow';
import { motion, AnimatePresence } from 'framer-motion';

/* Admin roles skip onboarding — they are assigned via Supabase directly */
const ADMIN_ROLES = new Set(['platform_admin', 'label_admin']);

const OnboardingGate = () => {
  const { user, profile, profileLoading } = useAuth();
  const [showOnboarding, setShowOnboarding] = useState(false);

  useEffect(() => {
    if (!user || profileLoading || !profile) { setShowOnboarding(false); return; }

    /* Never show onboarding to admin roles */
    if (ADMIN_ROLES.has(profile.role)) { setShowOnboarding(false); return; }

    /* Show only if explicitly not onboarded */
    setShowOnboarding(profile.onboarded === false);
  }, [user, profile, profileLoading]);

  if (!showOnboarding) return null;

  return (
    <AnimatePresence>
      <motion.div
        className="fixed inset-0 z-[100] bg-black/95 backdrop-blur-md overflow-y-auto"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
      >
        <OnboardingFlow onComplete={() => setShowOnboarding(false)} />
      </motion.div>
    </AnimatePresence>
  );
};

export default OnboardingGate;